module.exports = __webpack_public_path__ + "static/img/motiraj.f78fdf2c.jpg";